module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-22.4cce2e12.png";